<template>
  <div class="modal-frame modal-medium" :class="{active:isOpen}" data-modal="table-settings">
    <div class="modal-frame-content">
      <button
          @click="$emit('close')"
          class="btn-close"
          rel="button_close"
          type="button"
          data-modal-close
          :disabled="isSubmitting"
      >
        <svg class="svg-cross">
          <use href="/img/sprite.svg#svg-cross"></use>
        </svg>
      </button>
      <div class="modal-frame-header">
        <div class="h3">{{ t('actions.columnSettings') }}</div>
      </div>
      <div class="modal-frame-body">
        <form class="table-settings" @submit.prevent="apply">
          <div class="table-settings-content py-30 border-block">
            <label
                v-for="item in items"
                :key="item.key"
                class="checkbox-label"
            >
              <input
                  type="checkbox"
                  :name="`column_${item.key}`"
                  :checked="localSelected.includes(item.key)"
                  :disabled="isSubmitting"
                  @change="toggleColumn(item.key, $event.target.checked)"
              >
              <span class="fake-checkbox"></span>
              <span class="checkbox-name">{{ item.label }}</span>
            </label>
          </div>
          <div class="form-footer pt-20">
            <div class="buttons-row flex-center pb-30">
              <button class="link-dotted" type="button" :disabled="isSubmitting" @click="selectAll">
                {{ t('settings.selectAll') }}
              </button>
              <button class="link-dotted" type="button" :disabled="isSubmitting" @click="clearAll">
                {{ t('settings.clearAll') }}
              </button>
            </div>
            <div class="buttons-row">
              <button class="btn w-100" type="submit" :disabled="!canApply">{{ t('modals.apply') }}</button>
              <button
                  @click="$emit('close')"
                  class="btn-outline w-100"
                  type="button"
                  :disabled="isSubmitting"
              >
                {{ t('modals.cancel') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'apply'],
  data: () => ({
    localSelected: [],
  }),
  setup() {
    const { t } = useI18n();
    return { t };
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(value) {
        if (value) {
          this.resetLocalSelected();
        }
      },
    },
    selected() {
      if (this.isOpen) {
        this.resetLocalSelected();
      }
    },
  },
  computed: {
    canApply() {
      return this.localSelected.length > 0 && !this.isSubmitting;
    },
  },
  methods: {
    resetLocalSelected() {
      this.localSelected = [...this.selected];
    },
    toggleColumn(key, checked) {
      if (checked && !this.localSelected.includes(key)) {
        this.localSelected.push(key);
      }
      if (!checked) {
        this.localSelected = this.localSelected.filter(item => item !== key);
      }
    },
    selectAll() {
      this.localSelected = this.items.map(item => item.key);
    },
    clearAll() {
      this.localSelected = [];
    },
    apply() {
      if (!this.canApply) {
        return;
      }
      this.$emit('apply', [...this.localSelected]);
    },
  },
}
</script>

<style scoped>
.modal-frame[data-modal="table-settings"] {
  padding-block: 1rem;
}

.modal-frame[data-modal="table-settings"] .modal-frame-content {
  box-sizing: border-box;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
}

.modal-frame-body,
.table-settings {
  min-height: 0;
}

.modal-frame-body {
  display: flex;
  overflow: hidden;
}

.table-settings {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
}

.table-settings-content {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-count: initial;
  column-width: auto;
  gap: 17px 1.875rem;
  min-height: 0;
  overflow-y: auto;
  padding-inline: 2px;
  scrollbar-gutter: stable;
}

.table-settings-content .checkbox-label {
  break-inside: avoid;
  margin-bottom: 0;
}

.form-footer {
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .modal-frame[data-modal="table-settings"] .modal-frame-content {
    width: calc(100% - 2rem);
    padding: 2.5rem 1.25rem 1.25rem;
  }

  .table-settings-content {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
